import { render, staticRenderFns } from "./CreateProductPrice.vue?vue&type=template&id=d88fe630&scoped=true&"
import script from "./CreateProductPrice.vue?vue&type=script&lang=js&"
export * from "./CreateProductPrice.vue?vue&type=script&lang=js&"
import style0 from "./CreateProductPrice.vue?vue&type=style&index=0&id=d88fe630&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88fe630",
  null
  
)

export default component.exports